function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 1.5H2C1.44772 1.5 1 1.94772 1 2.5V15.5C1 16.0523 1.44772 16.5 2 16.5H14C14.5523 16.5 15 16.0523 15 15.5V2.5C15 1.94772 14.5523 1.5 14 1.5Z",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 4.5C6.53043 4.5 7.03914 4.71071 7.41421 5.08579C7.78929 5.46086 8 5.96957 8 6.5V11.5C8 12.0304 7.78929 12.5391 7.41421 12.9142C7.03914 13.2893 6.53043 13.5 6 13.5",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 11.5C8 12.0304 8.21071 12.5391 8.58579 12.9142C8.96086 13.2893 9.46957 13.5 10 13.5",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 4.5C9.46957 4.5 8.96086 4.71071 8.58579 5.08579C8.21071 5.46086 8 5.96957 8 6.5",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 10.5H10",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgTextField = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTextField, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/text_field.ef2294ab.svg";
export { ForwardRef as ReactComponent };